'use client';

import {
  HomeLandingSections,
  HomeStoriesSection,
  HomeCommunitySection,
  HomeVoicesSection,
  HomeAboutSection,
  CommunityMatrimonyServices,
} from '@/components/homePageSections';

import { useState } from 'react';
import Header from '@/components/Header';
import HomeHeroSection from '@/components/HomeHeroSection';

const communityServices: { label: string; href?: string }[] = [
  { label: "Anubandh Arya Vaishya Komti" },
  { label: "Komti Samaj" },
  { label: "Anubandh Foundation" },
  { label: "Arya vaishya Komti Samaj" },
  { label: "Arya vaishya Komti Samaj Nagpur" },
  { label: "Arya Vaishya Komti Matrimonial" },
  { label: "Arya Vaishya Komti Samaj Pune" },
  { label: "Arya Vaishya Komti Samaj Pune Melava" },
  { label: "Arya Vaishya Komti Samaj Gotra List" },
  { label: "Arya Vaishya Komti Anubandh ID" },
  { label: "Arya Vaishya Komti Marriage Portal" },
  { label: "Komti Samaj Category" },
  { label: "Komti Samaj in Marathi" },
  { label: "Komti Caste" },
  { label: "Mamidwar Caste" },
  { label: "Wattamwar Caste" },
  { label: "Revanwar Caste" },
  { label: "Tatiwar Caste" },
  { label: "Banginwar Caste" },
  { label: "Kotwar Caste" },
  { label: "Damkondwar Caste" },
  { label: "Belgamwar Caste" },
  { label: "Gadewar Caste" },
  { label: "Kawtikwar Caste" },
  { label: "Jinturkar Caste" },
  { label: "Padmavar Caste" },
  { label: "Bejgamwar Caste" },
  { label: "Chinnawar Caste" },
  { label: "Palikondawar Caste" },
  { label: "Anubandh Marriage Bureau" },
  { label: "Anubandh portal registration" },
];

export default function AnubandhAryaVaishyaKomtiSamaj() {
  const [openFAQ, setOpenFAQ] = useState<number | null>(null);

  return (
    <div className="bg-white">
      {/* Transparent Header */}
      <Header variant="transparent" />

      <HomeHeroSection
        title="आर्य वैश्य कोमटी समाज वधू वरांसाठी"
        subtitle="महाराष्ट्रातील अग्रणी विवाहसंस्था"
        trackingSource="anubandh_arya_vaishya_komti_samaj_matrimony"
      />

      <HomeLandingSections />

      <HomeStoriesSection />

      <HomeCommunitySection />

      <HomeVoicesSection />

      <HomeAboutSection />

      {/* FAQ Section */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-bold text-center text-gray-900 mb-12">
            Frequently Asked Questions
          </h2>
          <div className="max-w-4xl mx-auto">
            <div className="space-y-4">
              {[
                {
                  question: "Which is the best matrimony for Arya Vaishya Komti Samaj?",
                  answer: "MarathiVadhuVarSuchak.com is the best matrimony site and mobile app for Arya Vaishya Komti Samaj brides and grooms."
                },
                {
                  question: "How to search Arya Vaishya Komti Samaj brides and grooms?",
                  answer: "Arya Vaishya Komti Samaj brides and grooms first register free (Anubandh Form) on MarathiVadhuVarSuchak.com. Then after profile verification & approval you can search (Anubandh ID) for suitable profiles from you community."
                },
                {
                  question: "Which is the best Arya Vaishya Komti Samaj Pune Matrimony?",
                  answer: "MarathiVadhuVarSuchak.com is the best matrimony site and mobile app for Arya Vaishya Komti Samaj brides and grooms staying at Pune."
                },
                {
                  question: "Which is the best Arya Vaishya Komti Samaj Nagpur Matrimony?",
                  answer: "MarathiVadhuVarSuchak.com is the best matrimony site and mobile app for Arya Vaishya Komti Samaj brides and grooms staying at Nagpur."
                }
              ].map((faq, index) => (
                <div key={index} className="bg-white border border-gray-200 rounded-xl overflow-hidden shadow-sm">
                  <button
                    onClick={() => setOpenFAQ(openFAQ === index ? null : index)}
                    className="w-full px-6 py-4 text-left flex items-center justify-between hover:bg-gray-50 transition-colors"
                  >
                    <h3 className="text-lg font-semibold text-gray-900">
                      {faq.question}
                    </h3>
                    <svg
                      className={`w-5 h-5 text-gray-500 transition-transform duration-300 ${
                        openFAQ === index ? 'rotate-180' : ''
                      }`}
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                    </svg>
                  </button>
                  <div
                    className={`px-6 transition-all duration-300 ease-in-out ${
                      openFAQ === index ? 'pb-4 max-h-96 opacity-100' : 'max-h-0 opacity-0 overflow-hidden'
                    }`}
                  >
                    <div className="text-gray-600 leading-relaxed py-3">
                      <p className="mb-3">{faq.answer}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <CommunityMatrimonyServices
        title="Arya Vaishya Komti Community"
        items={communityServices}
      />

    </div>
  );
}

